import React from 'react';
import BaseButton from 'components/atoms/baseButton';
import SunOutlinedIcon from 'components/atoms/icons/sun-outlined-icon';
import MoonOutlinedIcon from 'components/atoms/icons/moon-outlined-icon';
import { useTheme } from 'infrastructure/providers/theme';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

const ThemeSwitcher: React.FC = () => {
  const { t } = useTranslation();
  const { theme, changeTheme } = useTheme();
  const isDark = theme === 'dark';
  const isLight = theme === 'light';

  return (
    <li
      onClick={(e) => e.preventDefault()}
      className={classNames(s.item, s.theme)}
    >
      {t('labels.appearance')}
      <div>
        <BaseButton
          icon={<SunOutlinedIcon />}
          className={classNames(isLight && s.active)}
          type="secondary"
          rounded
          onClick={() => changeTheme('light')}
        />
        <BaseButton
          icon={<MoonOutlinedIcon />}
          className={classNames(isDark && s.active)}
          type="secondary"
          rounded
          onClick={() => changeTheme('dark')}
        />
      </div>
    </li>
  );
};

export default ThemeSwitcher;
